import React, { useState } from "react";
import { useApp } from "../../../context/AppContext";
import { toast } from "../../../components/ui/sonner";
import { errMsg } from "./cnShared";

export const EmpCurrencyControl = ({ emp, zh, onChanged }) => {
  const { api, user, permOf } = useApp();
  // 【2026-10-26 第四批】后端 cn_currency_put 改走动作点 /hrms/employees::pay-currency（默认 admin/ceo）；
  // 前端同源读取，管理员把该点授予别的岗位后，这个下拉立即出现。
  const canSetCurrency = permOf("/hrms/employees::pay-currency") ?? ["admin", "ceo"].includes(user?.role);
  const T = (z, e) => (zh ? z : e);
  const [busy, setBusy] = useState(false);
  const cur = emp.currency || (emp.branch === "cn" ? "CNY" : "USD");
  const change = async (v) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/hrms/cn-payroll/employees/${emp.id}/currency`, { currency: v || null });
      toast.success(T(`计薪币种已更新为 ${data.currency}`, `Pay currency set to ${data.currency}`)); onChanged(data);
    } catch (e) { toast.error(errMsg(e, T("更新失败", "Update failed"))); }
    setBusy(false);
  };
  return (
    <p className="flex items-center gap-1.5 flex-wrap">
      <span className="text-slate-400">{T("计薪币种：", "Pay currency: ")}</span>
      <span data-testid="hrms-emp-currency" className={`font-bold ${cur === "CNY" ? "text-red-600" : "text-slate-700"}`}>{cur === "CNY" ? "¥ CNY" : "$ USD"}</span>
      {emp.currencyOverride && <span className="text-[10px] text-amber-600">{T("（管理员覆盖）", "(admin override)")}</span>}
      {canSetCurrency && (
        <select data-testid="hrms-emp-currency-select" disabled={busy} className="text-[11px] rounded border border-slate-200 px-1.5 py-0.5" value={emp.currencyOverride || ""} onChange={(e) => change(e.target.value)}>
          <option value="">{T("按法人默认", "Entity default")}</option><option value="CNY">CNY ¥</option><option value="USD">USD $</option>
        </select>)}
    </p>
  );
};
